<template>
  <p class="p4 ProductForm__ReviewEyebrow">
    {{ store.terms.steppedbundle_review.title }}
  </p>
  <h1 class="t2 ProductForm__Title">
    {{ store.item.title }}
  </h1>
  <ul class="BundleReview__List">
    <li v-for="(component, index) in components" :key="component" class="BundleReview__ListItem BundleReview__ListItem--Stepped">
      <div class="BundleReview__Wrapper BundleReview__Wrapper--Stepped">
        <div class="BundleReview__Details BundleReview__Details--Stepped">
          <p class="t4">
            <span>{{ componentIndex(index) }}.</span>
            <span>{{ component.title }}</span>
          </p>
          <ul>
            <li v-for="option in selectedVariant(component)" :key="option">
              <p class="p5">{{ option.name }}: {{ option.value }}</p>
            </li>
            <li>
              <Price :item="store.item" :ready="store.promoReady" :variant="component.variantBySelectedOptions" :location="'stepped-review-component'" :step="store.steps[store.currentStep]" />
            </li>
            <li v-if="shipsBy(component)">
              <Backorder :date="shipsBy(component)" />
            </li>
          </ul>
          <button role="button" class="p5" @click="store.step(componentIndex(index))">
            {{ store.terms.steppedbundle_review.edit }}
          </button>
        </div>
        <picture>
          <source media="(min-width:320px)" :srcset="image(component).url" />
          <img lazy="lazy" :src="image(component).url" :alt="image(component).alt" />
        </picture>
      </div>
    </li>
  </ul>

  <Price :item="store.item" :ready="store.promoReady" :step="store.steps[store.currentStep]" :location="'stepped-bundle-review-sum'" :showMessaging="true" :components="components"> </Price>

  <ProductActions :isReviewStep="true" />
</template>

<script setup>
import { useProductStore } from './Composables/Store';
import { computed, onMounted } from 'vue';
import Backorder from './Backorder.vue';
import Price from '../Global/Price.vue';
import ProductActions from './ProductActions.vue';

const store = useProductStore();
const components = computed(() => store.getSelectedComponents);
const location = computed(() => 'stepped-bundle-review');
const componentIndex = (index) => (index += 1);
const selectedVariant = (component) => {
  const selection = component?.variantBySelectedOptions ?? false;
  const hasVariantFromSelections = Object.keys(selection).length > 0 ?? false;

  if (hasVariantFromSelections) return selection.selectedOptions;

  return component.variants[0].selectedOptions;
};

const image = (component) => {
  const selection = component?.variantBySelectedOptions ?? false;
  const hasVariantFromSelections = Object.keys(selection).length > 0 ?? false;

  if (hasVariantFromSelections) return selection.image;
  else return component.variants[0].image;
};

const shipsBy = (component) => {
  return component.variantBySelectedOptions?.shipsBy?.value || false;
};
onMounted(() => (store.$state.selected.components = components));
</script>
